module.exports = __webpack_public_path__ + "static/img/1808_2.56cc6cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1808_2.jpg
// module id = VulP
// module chunks = 1